import { Component, OnInit, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { OptionForSynthese } from './option-for-synthese';

@Component({
    selector: 'app-selection-category-synthese-chantier-box',
    templateUrl: './selection-category-synthese-chantier-box.html',
    styleUrls: ['./selection-category-synthese-chantier-box.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SelectionCategoryBoxDialog implements OnInit {

    Model: OptionForSynthese;

    constructor(
        public dialogRef: MatDialogRef<SelectionCategoryBoxDialog>,
        @Inject(MAT_DIALOG_DATA) public data) {

        this.Model = new OptionForSynthese()
    }

    ngOnInit() {
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    onConfirm() {
        this.dialogRef.close(this.Model);
    }
}
